/**
 * Dependencies.
 */
import { RouteConfig } from 'vue-router';

import TrackingOldScene from '@/modules/tracking-old/scenes/Tracking.view.vue';

/**
 * Routes.
 */
export default [
  {
    component: TrackingOldScene,
    name: 'TrackingOld',
    path: 'tracking/:trackingNumber'
  }
] as RouteConfig[];
